/**
 * 키오스크 아바타 페이지 레이아웃
 *
 * 웹 모드와 분리된 키오스크 전용 UI
 * - 음성 전용 (텍스트 입력 없음)
 * - 자동 재연결
 * - 60초 유휴 타이머
 * - Figma 디자인 기반 헤더 (로고 + 언어 선택)
 * - Figma 디자인 기반 인디케이터
 */

// 메인 컴포넌트
export { KioskAvatarPage } from './ui/kiosk-avatar-page'
export { default as KioskAvatarPageDefault } from './ui/kiosk-avatar-page'

// UI 컴포넌트
export { KioskCoverModal } from './ui/kiosk-cover-modal'
export { KioskIndicator } from './ui/kiosk-indicator'
export { KioskIdleTimer } from './ui/kiosk-idle-timer'
export { KioskHeader } from './ui/kiosk-header'
export {
  KioskLanguageButton,
  KioskLanguageDropdown,
  KioskLanguageSelector, // 하위 호환성
} from './ui/kiosk-language-selector'

// 훅
export { useKioskAvatarPage } from './model/use-kiosk-avatar-page'
export type { UseKioskAvatarPageReturn } from './model/use-kiosk-avatar-page'

// 타입
export type {
  KioskIndicatorState,
  KioskCoverModalProps,
  KioskIndicatorProps,
  KioskLanguageSelectorProps,
  SupportedKioskLanguage,
  LanguageInfo,
  IdleTimerOptions,
  KioskAvatarPageProps,
  KioskHeaderProps,
  KioskLanguageButtonProps,
  KioskLanguageDropdownProps,
  KioskLoadingPhase,
} from './types/kiosk-config'

export {
  KIOSK_LANGUAGES,
  INDICATOR_STATUS_TEXT,
  KIOSK_LOADING_MESSAGES,
  HEADER_TITLE_TEXT,
} from './types/kiosk-config'
